import { metricsBus } from "buses";
import amplitudeAnalytics from "services/amplitude/amplitudeAnalytics";
import amplitudeExperiments from "services/amplitude/amplitudeExperiments";

const isWatchPage = () => window.location.pathname.indexOf("/watch/") === 0;

const isFullscreen = () => {
  return !!document.querySelector("#root")?.classList?.contains("fullScreen");
};

metricsBus.on("forceFullscreenEntered",() => amplitudeAnalytics.sendForcedFullscreenEntered());

metricsBus.on("forceFullscreenExited", () => amplitudeAnalytics.sendForcedFullscreenExitClicked());

metricsBus.on("uploadStarted", () => amplitudeAnalytics.sendUploadStarted());

metricsBus.on("uploadTagSelectionStarted", () => amplitudeAnalytics.sendUploadTagSelectionStarted());

metricsBus.on("uploadTagSelectionEnded", ({ count }) => amplitudeAnalytics.sendUploadTagSelectionEnded(count));

metricsBus.on("uploadEnded", () => amplitudeAnalytics.sendUploadEnded());

metricsBus.on("watchPageVisited", () => amplitudeAnalytics.sendWatchPageVisited());

metricsBus.on("gifView", ({ gifId }) => {
  if (isWatchPage()) {
    return amplitudeAnalytics.sendWatchViewed(gifId, isFullscreen());
  }
});

metricsBus.on("meaningfulGifView", ({ gifId }) => {
  if (isWatchPage()) {
    return amplitudeAnalytics.sendWatchViewedMeaningful(gifId, isFullscreen());
  }
});

metricsBus.on("gifLiked", ({ gifId }) => {
  if (isWatchPage()) {
    return amplitudeAnalytics.sendWatchLiked(gifId, isFullscreen());
  }
});

metricsBus.on("gifUnliked", ({ gifId }) => {
  if (isWatchPage()) {
    return amplitudeAnalytics.sendWatchUnliked(gifId, isFullscreen());
  }
});

metricsBus.on("addedToCollection", ({ gifId }) => {
  if (isWatchPage()) {
    return amplitudeAnalytics.sendWatchAddedToCollection(gifId, isFullscreen());
  }
});

metricsBus.on("fullscreenEntered", () => {
  return amplitudeAnalytics.sendFullscreenEntered();
});

metricsBus.on("fullscreenExited", () => {
  return amplitudeAnalytics.sendFullscreenExited();
});

metricsBus.on("menuButtonClicked", ({ label }) => amplitudeAnalytics.sendNavButtonClicked(label));

metricsBus.on("searchBarOpened", () => amplitudeAnalytics.sendSearchBarClicked());

metricsBus.on("searched", ({ query }) => amplitudeAnalytics.sendSearchQuerySubmitted(query));

metricsBus.on("loginCompleted", () => amplitudeAnalytics.sendLoginCompleted());

metricsBus.on("userFetched", ({ user }) => amplitudeAnalytics.identifyUser(user));

metricsBus.on("deviceTracked", ({ deviceId, deviceType }) => {
  amplitudeAnalytics.setDeviceId(deviceId);
  amplitudeAnalytics.updateUserProperties({ "Device Type": deviceType });
});

metricsBus.on("experimentVariantExposure", ({ experimentKey, experimentVariant }) => {
  amplitudeExperiments.exposure(experimentKey);
  amplitudeAnalytics.updateUserProperties({ [experimentKey]: experimentVariant });
});

metricsBus.on("firstPageVisited", ({ path }) => {
  if (path.startsWith("/watch/")) {
    amplitudeAnalytics.updateUserProperties({
      "Landed to Watch Page": true
    });
  }
});

